// Sidebar.js - Updated with role-based menu items
import React, { useState } from 'react';
import "../Css/Sidebar.css";
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTachometerAlt, 
  faFileAlt, 
  faBriefcase, 
  faCube, 
  faCogs, 
  faSignOutAlt,
  faUsers,
  faLayerGroup,
  faDiagramProject,
  faFile
} from '@fortawesome/free-solid-svg-icons';
import LogoutModal from './LogoutModal';

export default function Sidebar({ isCollapsed }) {
  const location = useLocation();
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  // Get user data from localStorage
  const getUserData = () => {
    try {
      const userData = localStorage.getItem('user');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  };

  const user = getUserData();
  const userRole = user?.role || 'user';

  const handleLogoutClick = () => {
    setIsLogoutModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsLogoutModalOpen(false);
  };

  // Define all menu items
  const allMenuItems = [
    { path: "/admin/dashboard", label: "Dashboard", icon: faTachometerAlt },
    { path: "/admin/services", label: "Services", icon: faCogs },
    { path: "/admin/projects", label: "Projects", icon: faDiagramProject },
    { path: "/admin/products", label: "Products", icon: faCube },
    { path: "/admin/blogs", label: "Blogs", icon: faFileAlt },
    { path: "/admin/users", label: "Users", icon: faUsers },
    { path: "/admin/categories", label: "Categories", icon: faLayerGroup },
    { path: "/admin/careers", label: "Careers", icon: faBriefcase },
    { path: "/admin/careers/applications", label: "Career Applications", icon: faFile },
  ];

  // Filter menu items based on user role
  const getMenuItems = () => {
    if (userRole === 'admin') {
      return allMenuItems; // Admin sees all pages
    } else {
      // Regular users only see Blogs page
      return allMenuItems.filter(item => item.path === "/admin/blogs");
    }
  };

  const menuItems = getMenuItems();

  return (
    <>
      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="sidebar-logo">
          {isCollapsed ? (
            <div className="logo-icon">S</div>
          ) : (
            <img src="/images/Logo-Safpro__1.png" alt="Logo" />
          )}
        </div>

        <div className="sidebar-content">
          <nav className="sidebar-menu">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
                title={isCollapsed ? item.label : ''}
              >
                <FontAwesomeIcon icon={item.icon} />
                {!isCollapsed && <span>{item.label}</span>}
              </Link>
            ))}
          </nav>
        </div>

        <div className="sidebar-logout">
          <button 
            className="logout-btn" 
            onClick={handleLogoutClick}
            title={isCollapsed ? 'Logout' : ''}
          >
            <FontAwesomeIcon icon={faSignOutAlt} />
            {!isCollapsed && <span>Logout</span>}
          </button>
        </div>
      </div>

      <LogoutModal 
        isOpen={isLogoutModalOpen} 
        onClose={handleCloseModal} 
      />
    </>
  );
}